export class Paginator {
  private _count = 0;
  private _currentPage = 1;
  pageCount = 1;

  constructor(
    public countByPage = 50
  ) {
  }

  set count(value: number) {
    this._count = value;
    this.pageCount = Math.max(1, Math.ceil(this._count / this.countByPage));
  }

  get count(): number {
    return this._count;
  }

  set currentPage(value: number) {
    this._currentPage = value;
  }

  get currentPage(): number {
    return Math.min(this._currentPage, this.pageCount);
  }

  reset(): void {
    this.currentPage = 1;
  }
}
